import { User } from '@/api/model/user'
import { BaseModel } from '@/api/base-model'
import { EventLogAPI } from '@/api/backend-client'
import { Referral } from '@/api/model/referral'
import { Contact } from '@/api/model/contact'

export class EventLog extends BaseModel<EventLog> {
    protected collectionName = EventLogAPI.collectionName

    constructor(
        public id: string,
        public event: string,
        public eventData: any,
        public loggedAt: Date,
        public contact?: Contact,
        public referral?: Referral,
        public pipelineName?: string,
        public loggedBy?: User,
    ) {super(id)}

    static fromData(data: any): EventLog {
        if (data === null || typeof data === 'string' || data instanceof EventLog) {
            return data
        }

        return new EventLog(
            data.id,
            data.event,
            data.eventData,
            data.loggedAt,
            data.contact,
            data.referral,
            data.pipelineName,
            data.loggedBy,
        )
    }

    get name(): string {
        if (!this.loggedBy) {
            return 'Virtuele Collega'
        }

        return [this.loggedBy.firstname, this.loggedBy.middlename, this.loggedBy.lastname]
            .filter(value => value !== null)
            .join(' ')
    }
}

